// Component: WithLayout.jsx
// Purpose: Auth'd wrapper for the routes that live outside MainLayout (/profile,
//   the StrategyBuilder routes). It owns ONE thing now — the WebSocketProvider
//   (and the access-token plumbing that feeds it) — and delegates ALL chrome to
//   AppShell.
//
// Why: this used to inline its own desktop Sidebar + Navbar and had no phone or
// tablet tier. That made the pages routed through it inconsistent with the rest
// of the app — on a phone they dropped users into desktop chrome with no bottom
// nav and no way back, and on a tablet they showed the full sidebar while every
// other screen showed the collapsed icon rail. AppShell is "the one responsive
// frame for the authenticated app" (desktop sidebar / tablet NavRail / phone
// MobileHeader + BottomTabBar), and it renders chrome ONLY — data providers stay
// with the caller — so it composes cleanly inside the provider below. This is
// exactly the de-duplication AppShell was created for.

import React, { useState, useEffect } from "react";
import { useAuth } from "../contexts/AuthContext";
import { WebSocketProvider } from "../context/WebSocketProvider";
import AppShell from "./shell/AppShell";

const WithLayout = ({ children }) => {
  const { user } = useAuth();
  const [accessToken, setAccessToken] = useState(() => localStorage.getItem("accessToken"));

  useEffect(() => {
    const handleStorageChange = (e) => {
      if (e.key === "accessToken") {
        setAccessToken(e.newValue);
      }
    };

    const tokenCheckInterval = setInterval(() => {
      const currentToken = localStorage.getItem("accessToken");
      if (currentToken !== accessToken) {
        setAccessToken(currentToken);
      }
    }, 5000);

    window.addEventListener("storage", handleStorageChange);

    return () => {
      window.removeEventListener("storage", handleStorageChange);
      clearInterval(tokenCheckInterval);
    };
  }, [accessToken]);

  return (
    <WebSocketProvider authToken={accessToken} userId={user?.id || user?.user_id}>
      <AppShell>{children}</AppShell>
    </WebSocketProvider>
  );
};

export default WithLayout;
